module.exports = __webpack_public_path__ + "static/media/digitalPolicy.31789786.svg";